// extracted by mini-css-extract-plugin
module.exports = {"content":"ErrorModal_content__p1xwX","title":"ErrorModal_title__3bVXb","body":"ErrorModal_body__2iDqQ","buttonBox":"ErrorModal_buttonBox__sX05P"};